import { PROPOSAL_ACCENT } from "@/lib/proposalTheme";
import { cn } from "@/lib/utils";

const BANNER_TEXT = "LINK A — Internal Preview";

type Props = {
  /** Fixed bottom-left overlay (proposal previews) vs full-width top bar (interactive project). */
  variant?: "fixed" | "top";
  className?: string;
};

/** Compact single-line staff indicator for Link A internal preview routes. */
export default function ProposalLinkAInternalPreviewBanner({ variant = "fixed", className }: Props) {
  if (variant === "top") {
    return (
      <div
        className={cn(
          "border-b px-4 py-2 text-center text-xs font-semibold tracking-wide md:px-8",
          className,
        )}
        style={{
          borderColor: PROPOSAL_ACCENT,
          background: "rgba(200,169,106,0.14)",
          color: "#1A2744",
        }}
        role="status"
        aria-label={BANNER_TEXT}
      >
        <p className="mx-auto max-w-6xl">{BANNER_TEXT}</p>
      </div>
    );
  }

  return (
    <div
      className={cn(
        "rounded-md border px-3 py-1.5 text-xs font-semibold tracking-wide shadow-sm proposal-no-print",
        className,
      )}
      style={{
        borderColor: PROPOSAL_ACCENT,
        background: "rgba(200,169,106,0.16)",
        color: "#1A2744",
      }}
      role="status"
      aria-label={BANNER_TEXT}
    >
      {BANNER_TEXT}
    </div>
  );
}
